import { SortableHandle } from 'react-sortable-hoc';
import { Icon } from 'antd';
import React from 'react';

const DragHandle = SortableHandle(() => (
  <Icon
    className="draggable"
    style={{ fontSize: 16 }}
    type="more"
    onClick={e => {
      e.stopPropagation();
    }}
  />
));
export default DragHandle;
